module.exports = __webpack_public_path__ + "static/full-climastatus.9bd248a0.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/full-climastatus.gif
// module id = 223
// module chunks = 35783957827783 213720915766396